import PropTypes from 'prop-types';
import style from './SettingsPanel.module.css';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../colorVars';
import { updateTradePlanConfiguration } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updateTradePlanConfiguration';
import { SettingsPanelHeader } from './SettingsPanelHeader';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';

// eslint-disable-next-line no-unused-vars
export const SettingsPanel = observer(({ tradePlanId, addTab, ...rest }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  if (!tradePlan) return null;

  return (
    <TabPanel {...rest}>
      <div className={style.container}>
        <table className={style.table}>
          <SettingsPanelHeader />
          <tbody className={style.tbody}>
            <tr>
              <td>
                <Body3 color={colors.lightGrey} fontWeight={700}>
                  Flatten at Close
                </Body3>
              </td>
              <td>
                <div className={style.buttonWrapper}>
                  <CheckBox
                    fontSize="10px"
                    checked={tradePlan.flattenAtMarketClose}
                    onChange={(checked) =>
                      updateTradePlanConfiguration(
                        tradePlanId,
                        'FLATTEN_AT_MARKET_CLOSE',
                        { flattenAtMarketClose: checked }
                      )
                    }
                  />
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
            </tr>
            <tr>
              <td>
                <Body3 color={colors.lightGrey} fontWeight={700}>
                  Work Orders
                </Body3>
              </td>
              <td>
                <div className={style.buttonWrapper}>
                  <CheckBox
                    fontSize="10px"
                    checked={tradePlan.workOrders}
                    onChange={(checked) =>
                      updateTradePlanConfiguration(tradePlanId, 'WORK_ORDERS', {
                        field: 'workOrders',
                        value: checked,
                      })
                    }
                  />
                </div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            {tradePlan.workOrders ? (
              <>
                <tr>
                  <td>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Entry
                    </Body3>
                  </td>
                  <td>
                    <div className={style.buttonWrapper}>
                      <CheckBox
                        disabled={tradePlan.inPosition}
                        fontSize="10px"
                        checked={tradePlan.workOrdersOnEntry}
                        onChange={(checked) =>
                          updateTradePlanConfiguration(
                            tradePlanId,
                            'WORK_ORDERS',
                            {
                              field: 'workOrdersOnEntry',
                              value: checked,
                            }
                          )
                        }
                      />
                    </div>
                  </td>
                  <td>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Exit
                    </Body3>
                  </td>
                  <td>
                    <div className={style.buttonWrapper}>
                      <CheckBox
                        fontSize="10px"
                        checked={tradePlan.workOrdersOnExit}
                        onChange={(checked) =>
                          updateTradePlanConfiguration(
                            tradePlanId,
                            'WORK_ORDERS',
                            {
                              field: 'workOrdersOnExit',
                              value: checked,
                            }
                          )
                        }
                      />
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                {tradePlan.workOrdersOnExit ? (
                  <tr>
                    <td>
                      <Body3 color={colors.lightGrey} fontWeight={700}>
                        Decouple Exit
                      </Body3>
                    </td>
                    <td>
                      <div className={style.buttonWrapper}>
                        <CheckBox
                          disabled={tradePlan.inPosition}
                          fontSize="10px"
                          checked={tradePlan.useDifferentWorkOrderFieldsOnExit}
                          onChange={(checked) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'useDifferentWorkOrderFieldsOnExit',
                                value: checked,
                              }
                            )
                          }
                        />
                      </div>
                    </td>
                    <td>
                      <Body3 color={colors.lightGrey} fontWeight={700}>
                        Decouple Target
                      </Body3>
                    </td>
                    <td>
                      <div className={style.buttonWrapper}>
                        <CheckBox
                          fontSize="10px"
                          checked={
                            tradePlan.useDifferentWorkOrderFieldsOnTarget
                          }
                          onChange={(checked) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'useDifferentWorkOrderFieldsOnTarget',
                                value: checked,
                              }
                            )
                          }
                        />
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                ) : null}
                <tr>
                  <td>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      Work Order Limit
                    </Body3>
                  </td>
                  <td>
                    <div className={style.inputWrapper}>
                      <EditableTableField
                        bodySize={3}
                        color={colors.lightGrey}
                        backgroundColor="inherit"
                        initialValue={tradePlan.getAwayOffsetPct * 100}
                        updateValue={(value) =>
                          updateTradePlanConfiguration(
                            tradePlanId,
                            'WORK_ORDERS',
                            {
                              field: 'getAwayOffsetPct',
                              value: Number(value) / 100,
                            }
                          )
                        }
                      />
                      <Body3
                        margin="3px 0 0 0"
                        color={colors.lightGrey}
                        fontWeight={700}
                      >
                        %
                      </Body3>
                    </div>
                  </td>
                  <td>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      % Between Bid/Ask
                    </Body3>
                  </td>
                  <td>
                    <div className={style.inputWrapper}>
                      <EditableTableField
                        bodySize={3}
                        color={colors.lightGrey}
                        backgroundColor="inherit"
                        initialValue={tradePlan.pctBetweenBidAsk * 100}
                        updateValue={(value) =>
                          updateTradePlanConfiguration(
                            tradePlanId,
                            'WORK_ORDERS',
                            {
                              field: 'pctBetweenBidAsk',
                              value: Number(value) / 100,
                            }
                          )
                        }
                      />
                      <Body3
                        margin="3px 0 0 0"
                        color={colors.lightGrey}
                        fontWeight={700}
                      >
                        %
                      </Body3>
                    </div>
                  </td>
                  <td>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      % Increase/Attempt
                    </Body3>
                  </td>
                  <td>
                    <div className={style.inputWrapper}>
                      <EditableTableField
                        bodySize={3}
                        color={colors.lightGrey}
                        backgroundColor="inherit"
                        initialValue={
                          tradePlan.pctIncreasePerOrderAttempt * 100
                        }
                        updateValue={(value) =>
                          updateTradePlanConfiguration(
                            tradePlanId,
                            'WORK_ORDERS',
                            {
                              field: 'pctIncreasePerOrderAttempt',
                              value: Number(value) / 100,
                            }
                          )
                        }
                      />
                      <Body3
                        margin="3px 0 0 0"
                        color={colors.lightGrey}
                        fontWeight={700}
                      >
                        %
                      </Body3>
                    </div>
                  </td>
                </tr>
                {tradePlan.useDifferentWorkOrderFieldsOnExit ? (
                  <tr>
                    <td>
                      <Body3 color={colors.lightGrey} fontWeight={700}>
                        On Exit
                      </Body3>
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={tradePlan.getAwayOffsetPctOnExit * 100}
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'getAwayOffsetPctOnExit',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                    <td>
                      {/* <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Exit
                    </Body3> */}
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={tradePlan.pctBetweenBidAskOnExit * 100}
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'pctBetweenBidAskOnExit',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                    <td>
                      {/* <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Exit
                    </Body3> */}
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={
                            tradePlan.pctIncreasePerOrderAttemptOnExit * 100
                          }
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'pctIncreasePerOrderAttemptOnExit',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                  </tr>
                ) : null}
                {tradePlan.useDifferentWorkOrderFieldsOnTarget ? (
                  <tr>
                    <td>
                      <Body3 color={colors.lightGrey} fontWeight={700}>
                        On Target
                      </Body3>
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={
                            tradePlan.getAwayOffsetPctOnTarget * 100
                          }
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'getAwayOffsetPctOnTarget',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                    <td>
                      {/* <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Target
                    </Body3> */}
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={
                            tradePlan.pctBetweenBidAskOnTarget * 100
                          }
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'pctBetweenBidAskOnTarget',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                    <td>
                      {/* <Body3 color={colors.lightGrey} fontWeight={700}>
                      On Target
                    </Body3> */}
                    </td>
                    <td>
                      <div className={style.inputWrapper}>
                        <EditableTableField
                          bodySize={3}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                          initialValue={
                            tradePlan.pctIncreasePerOrderAttemptOnTarget * 100
                          }
                          updateValue={(value) =>
                            updateTradePlanConfiguration(
                              tradePlanId,
                              'WORK_ORDERS',
                              {
                                field: 'pctIncreasePerOrderAttemptOnTarget',
                                value: Number(value) / 100,
                              }
                            )
                          }
                        />
                        <Body3
                          margin="3px 0 0 0"
                          color={colors.lightGrey}
                          fontWeight={700}
                        >
                          %
                        </Body3>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </>
            ) : null}
            <tr>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
              <td>
                <Body3 color={colors.grey} fontWeight={700}>
                  -
                </Body3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </TabPanel>
  );
});

SettingsPanel.propTypes = {
  addTab: PropTypes.any,
  tradePlanId: PropTypes.any,
};

SettingsPanel.tabsRole = 'TabPanel';
